import { useReducer } from "react";
import {
  Configuration,
  Dimensions,
  Parapet,
  Roof,
  Gutter,
  Wall,
  OptionsMaterial,
  Spy,
  SunScreen,
  Lights,
  RoofGlassMat,
} from "src/types/configuration";

type State = Configuration;
type Action =
  | { type: "SET_CONFIGURATION"; payload: Configuration }
  | { type: "SET_ROOF_TYPE"; payload: string }
  | { type: "SET_DIMENSIONS"; payload: Dimensions }
  // | { type: "SET_PARAPET"; payload: Parapet }
  | { type: "SET_ROOF"; payload: Roof }
  | { type: "SET_GUTTER"; payload: Gutter }
  | { type: "SET_WALLS"; payload: Wall[] }
  // | { type: "SET_STORAGES"; payload: { left: boolean; right: boolean } }
  | { type: "SET_OPTION_MATERIAL"; payload: OptionsMaterial }
  | { type: "SET_SPY"; payload: Spy }
  | { type: "SET_SUNSCREEN"; payload: SunScreen }
  | { type: "SET_ROOF_MATERIAL"; payload: string }
  | { type: "SET_LIGHTS"; payload: Lights }
  | { type: "SET_ROOFGLASSMAT"; payload: RoofGlassMat };

const initialConfiguration: Configuration = {
  roofType: "oase",
  roofMaterial: "mat_black",
  dimensions: {
    width: 5000,
    depth: 3000,
    height: 2350,
    angle: 8,
    overhangFront: 150,
    overhangBack: 0,
    overhangLeft: 0,
    overhangRight: 0,
    leftStorageWidth: 3000,
    rightStorageWidth: 3000,
    frontlimit: 4000,
  },
  // parapet: { enabled: false, height: 50, type: "metselwerk" },
  roof: {
    type: "empty",
    epdmGlue: false,
    walls: {
      left: {
        name: "empty",
        rotate: false,
        innerWallEnabled: false,
        innerWallType: "naturel",
        outerWallType: "naturel",
        window: "wit",
      },
      right: {
        name: "empty",
        rotate: false,
        innerWallEnabled: false,
        innerWallType: "naturel",
        outerWallType: "naturel",
        window: "wit",
      },
    },
  },
  gutter: { enabled: false, type: "default" },
  walls: [],
  // storages: { left: false, right: false },
  optionsMaterial: {
    liter_beits_zwart: 0,
    liter_beits_wit: 0,
    liter_beits_gray: 0,
    liter_beits_douglas: 0,
    poer: "empty",
    fundering: "empty",
    poerQuantity: 0,
    daktrim_blank: false,
    daktrim_zwart: true,
  },
  params: {
    platdakColumn: 140,
    kapschuurColumn: 140,
    kapschuurRoofThickness: 390,
    kapschuurOverhang: 1391,
    kapschuurOverhangLength: 1607,
    kapschuurOverhangSmallAngle: 30,
    kapschuurOverhangBigAngle: 20,
    kapschuurBigHeight: 3000,
    kapschuurSmallHeight: 1860,
  },
  spy: {
    enabled: true,
    sameMaterial: true,
    left: false,
    right: false,
    alumspy: false,
    // material: "string",
    // polymat: "string",
    // glassmat: "string",
    // glasslightCheck: false,
  },
  sunScreen: {
    enabled: false,
    top: false,
    color: "default",
    cover: "100",
  },
  lights: {
    enabled: false,
    lightsOn: false,
    everyLigger: true,
    glow: false,
  },
  roofGlassMat: {
    glass: "poly",
    polyshade: "mid",
    glassshade: "light",
  },
};

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "SET_CONFIGURATION":
      return { ...action.payload };
    case "SET_ROOF_TYPE":
      return { ...state, roofType: action.payload };
    case "SET_DIMENSIONS":
      return { ...state, dimensions: action.payload };
    // case "SET_PARAPET":
    //   return { ...state, parapet: action.payload };
    case "SET_ROOF":
      return { ...state, roof: action.payload };
    case "SET_ROOF_MATERIAL":
      return { ...state, roofMaterial: action.payload };
    case "SET_GUTTER":
      return { ...state, gutter: action.payload };
    case "SET_WALLS":
      return { ...state, walls: action.payload };
    // case "SET_STORAGES":
    //   return { ...state, storages: action.payload };
    case "SET_OPTION_MATERIAL":
      return { ...state, optionsMaterial: action.payload };
    case "SET_SPY":
      return { ...state, spy: action.payload };
    case "SET_SUNSCREEN":
      return { ...state, sunScreen: action.payload };
    case "SET_LIGHTS":
      return { ...state, lights: action.payload };
    case "SET_ROOFGLASSMAT":
      return { ...state, roofGlassMat: action.payload };
    default:
      return state;
  }
}

const useConfigurationState = () => {
  const [state, dispatch] = useReducer(reducer, initialConfiguration);

  return { state, dispatch };
};

export default useConfigurationState;
